import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'
import {SystemSelector }from '/app/src/model/System'

import AssignedOptions from './Assigned';
import ConversationSelector from '/app/src/model/Conversation/selector'
import UnassignedOptions from './Unassigned';
import MainMenuRightPanel from '/app/src/layout/Dashboard/RightPanel/MainMenu'

class ConversationRightPanel extends React.Component {
    render() {
        let option;

        switch(this.props.type) {
            case 'assigned':
                option = <AssignedOptions room={this.props.room}/>;
                break;
            case 'unassigned':
                option = <UnassignedOptions room={this.props.room}/>;
                break;
            case 'coworker':
            default:
                option = <MainMenuRightPanel/>
                break;
        }
        return (
            <Flex width="100%" height='100%'>
                {option}
            </Flex>
        )
    }


}
function mapStateToProps(state, ownProps){
    let params = SystemSelector.getParams(state)
    let room = params[1];
    let conversation = ConversationSelector.getByRoom(state, room);

    let type = null;
    if(conversation){
        type = ConversationSelector.getType(conversation);
    }
    return {
        'type': type,
        'room': room,
        'conversation': conversation
    }

}


export default connect(mapStateToProps)(ConversationRightPanel)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/index.js